module.exports = __webpack_public_path__ + "static/media/signage-indoor-img57.12f5c6aa.jpg";